import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasClasificarmovimientosIndividualComponent ($q, $catalogos, FinanzasClasificarMovimientos) {
  var $ctrl = this;
  $ctrl.$onInit = $onInit;
  $ctrl.actualizar = actualizar;
  $ctrl.clasificarMovimientos = clasificarMovimientos;
  $ctrl.$onChanges = $onChanges;

  function $onInit () {
    $ctrl.data = null;
  }

  function $onChanges (changes) {
    if (changes.cuentabancaria) {
      $ctrl.data = null;
    }
  }

  function actualizar (data) {
    $ctrl.data = data;
    var datos = filtarClasificantes();
    $ctrl.clasificando = datos.length <= 0;
  }

  function filtarClasificantes () {
    var datos = $ctrl.data.filter(function (item) {
      return item.ID_Empleado && item.Folio && !item.existeenDetallePago;
    });
    return datos;
  }

  function clasificarMovimientos () {
    $ctrl.clasificando = true;
    var datos = filtarClasificantes();
    FinanzasClasificarMovimientos.clasificarmovimientos($ctrl.cuentabancaria.ID_Cliente, $ctrl.cuentabancaria.ID_Cuenta, datos).then(function (response) {
      $ctrl.data.map(function (item) {
        response.data.filter(function (elemento) {
          if (item.Folio === elemento.Folio)
            item.existeenDetallePago = true;
        });
      });
    });
  }
}

module.component('finanzasClasificarmovimientosIndividual', {
  controller: FinanzasClasificarmovimientosIndividualComponent,
  template,
  bindings: {
    cuentabancaria: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/clasificarmovimientos/components/individual/component.js